import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { LargeOrderPromoCard, FormType } from '@/models';
import { Routes } from '@/router';
import { ColorStyle, BackgroundColorStyle, BorderColorStyle } from '@/models/util';
import { ui } from '@/constants';
import { getLargeOrderPromoCardInteraction } from '@/services/analytics/platforms/adobe-analytics/helpers';

@Component({
  name: 'CmgLargeOrderPromoCard',
})
export default class CmgLargeOrderPromoCard extends Vue {
  @Prop({ required: true, type: Object })
  largeOrderCardData!: LargeOrderPromoCard;

  @Prop({ required: true, type: Number })
  cardIndex!: number;

  isLoading = false;

  get imageUrl(): string | undefined {
    return this.largeOrderCardData.imageUrl;
  }

  get backgroundColor(): BackgroundColorStyle {
    return { 'background-color': this.largeOrderCardData.backgroundColor || 'white' };
  }

  get title(): string | undefined {
    return this.largeOrderCardData.title;
  }

  get titleColor(): ColorStyle {
    return { color: this.largeOrderCardData.titleColor || 'white' };
  }

  get detailsCopy(): string | undefined {
    // inject ADA tab index
    return this.largeOrderCardData.detailsCopy?.replace('>', ` tabindex=\"-1\">`);
  }

  get detailsCopyColor(): ColorStyle {
    return { color: this.largeOrderCardData.detailsCopyColor || ui.colors.brownLight };
  }

  get boldCopy(): string | undefined {
    return this.largeOrderCardData.boldCopy;
  }

  get boldCopyColor(): ColorStyle {
    return { color: this.largeOrderCardData.boldCopyColor || ui.colors.brown };
  }

  get buttonText(): string | undefined {
    return this.largeOrderCardData.buttonText;
  }

  get buttonStyle(): ColorStyle & BackgroundColorStyle & BorderColorStyle {
    const buttonColor = this.largeOrderCardData.buttonColor || ui.colors.gold;
    return { color: this.largeOrderCardData.buttonTextColor || 'white', 'background-color': buttonColor, 'border-color': buttonColor };
  }

  get isGroupOrder(): boolean {
    return !this.largeOrderCardData.navUrl;
  }

  // Used by Google Analytics
  get dataButtonValue(): string {
    return this.isGroupOrder ? 'group-order-cta' : 'catering-order-cta';
  }

  // Currently, we have only catering and group order actions.
  // Catering has a URL provided in AEM, group order does not.
  // If we ever have the need to change the actions of these buttons,
  // we will need to re-think how to handle actions in AEM.
  async onClickButton(event: any): Promise<void> {
    if (this.largeOrderCardData.navUrl) {
      // external nav
      this.$services.analytics.addLinkClickedEventToStore(getLargeOrderPromoCardInteraction(this.largeOrderCardData, this.cardIndex), this.largeOrderCardData.navUrl);
      window.location.href = this.largeOrderCardData.navUrl;
      return;
    }
    this.$services.analytics.addLinkClickedEventToStore(getLargeOrderPromoCardInteraction(this.largeOrderCardData, this.cardIndex), this.largeOrderCardData.navUrl);
    this.$services.ui.firstFocus();
    // Group Order clicked
    this.isLoading = true;
    await this.$services.customer.waitForCustomerInitialization();
    const customer = this.$appStore.state.customer.profile;
    if (customer && !customer.isGuest) {
      try {
        if (await this.$services.order.doesInProgressHostGroupOrderExist()) {
          const lastItem = { one: 'bag' };
          sessionStorage.setItem('lastSelectedElement', JSON.stringify(lastItem));
          this.$services.bag.setBagVisibility(true);
          this.$services.ui.focusDiv('.fullModal');
        } else {
          this.$router.push({ name: Routes.GroupOrderCreate });
        }
      } finally {
        this.isLoading = false;
      }
    } else {
      this.$services.ui.setModalVisibility('signIn', true, { route: Routes.GroupOrderCreate, type: FormType.GroupOrderSignIn });
    }

    this.isLoading = false;
  }
}
